import React from "react";
import { Navigate } from "react-router-dom";
const RoleRoute = ({ blockedRoles = [], children }) => {

const userRole = Number(sessionStorage.getItem("userRole"));

  if (blockedRoles.includes(userRole)) {
    return <Navigate to="/notfound" replace />;
  }

  return children;
};

export default RoleRoute;